(function() {
  var AccessController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.UploadsController = (function(superClass) {
    extend(UploadsController, superClass);

    function UploadsController(scope, transitions, service, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.http = http;
      this.deleteFile = bind(this.deleteFile, this);
      this.userChanged = bind(this.userChanged, this);
      UploadsController.__super__.constructor.call(this, 'uploads', this.http);
      this.scope.title = 'Uploads';
      this.scope.fullpage = true;
      this.scope.absolute_errors = true;
      this.scope.user_id = null;
      this.scope.file_id = null;
      this.scope.users = [];
      this.scope.files = [];
      this.scope.userChanged = this.userChanged;
      this.scope.deleteFile = this.deleteFile;
      this.service.getUsers().then((function(_this) {
        return function(response) {
          return _this.scope.users = response.data.data;
        };
      })(this));
    }

    UploadsController.prototype.userChanged = function() {
      this.scope.file_id = null;
      return this.service.getFiles(this.scope.user_id).then((function(_this) {
        return function(response) {
          return _this.scope.files = response.data.data;
        };
      })(this));
    };

    UploadsController.prototype.deleteFile = function() {
      return this.service.deleteFile(this.scope.file_id).then((function(_this) {
        return function(response) {
          if (response.data.data) {
            _this.setAlert({
              type: 'success',
              msg: 'File successfully deleted'
            }, [], 2500);
          } else {
            _this.setAlert({
              type: 'danger',
              msg: 'Failed to delete file'
            }, [], 2500);
          }
          return _this.service.getFiles(_this.scope.user_id).then(function(response) {
            return _this.scope.files = response.data.data;
          });
        };
      })(this));
    };

    return UploadsController;

  })(AccessController);

}).call(this);
